import { useMemo } from 'react'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { OrderProductTypesButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import { AdjustmentDownloadButtonCSV, AdjustmentPdfPreview, AdjustmentDownloadPdfTemplateButton, AdjustmentDownloadButtonPDF } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderAdjustmentDeliveryNoteLayout/AdjustmentButtons'

const AdjustmentDeliveryNoteFinishedStepButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useAdjustmentDeliveryNoteFinishedStepButtonsLogic, ...rest }} className='mr-8' />
    )
}

const useAdjustmentDeliveryNoteFinishedStepButtonsLogic = ({ data, onSubmit, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const Order = data?.header
    const name = 'adjustment_delivery_note_finished_step_buttons'

    const defaultButtons = [{ "id": "previewAdjustmentDeliveryNotePDF" }, { "id": "downloadAdjustmentDeliveryNote" }, { "id": "duplicateAdjustmentDeliveryNote" }]

    const adjustmentDeliveryNoteDownloadCSVText = t('downloadCsv', 'Descargar csv')
    const adjustmentDeliveryNotePreviewPDFText = t('previewPdfTemplate', 'Previsualizar plantilla PDF')
    const adjustmentDeliveryNoteDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const adjustmentDeliveryNoteDownloadPDFText = t('downloadPdf', 'Descargar PDF')
    const adjustmentOrderProductTypesText = t('valueProductTypes', 'Valor tipos de producto')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            downloadAdjustmentCsv: {
                component: AdjustmentDownloadButtonCSV,
                extraProps: {
                    title: adjustmentDeliveryNoteDownloadCSVText,
                    id: 'downloadAdjustmentCsv',
                    Order,
                    typeTemplate: 'adjustmentDeliveryNote'
                }
            },
            previewAdjustmentDeliveryNotePDF: {
                component: AdjustmentPdfPreview,
                extraProps: {
                    title: adjustmentDeliveryNotePreviewPDFText,
                    id: 'previewAdjustmentDeliveryNotePDF',
                    key: 'previewAdjustmentDeliveryNotePDF',
                    Order,
                    typeTemplate: 'adjustmentDeliveryNote'
                }
            },
            downloadAdjustmentDeliveryNoteTemplate: {
                component: AdjustmentDownloadPdfTemplateButton,
                extraProps: {
                    title: adjustmentDeliveryNoteDownloadPDFTemplateText,
                    id: 'downloadAdjustmentDeliveryNoteTemplate',
                    key: 'downloadAdjustmentDeliveryNoteTemplate',
                    Order,
                    typeTemplate: 'adjustmentDeliveryNote'
                }
            },
            downloadAdjustmentDeliveryNote: {
                component: AdjustmentDownloadButtonPDF,
                extraProps: {
                    title: adjustmentDeliveryNoteDownloadPDFText,
                    id: 'downloadAdjustmentDeliveryNote',
                    Order,
                    typeTemplate: 'adjustmentDeliveryNote'
                }
            },
            adjustmentProductTypes: {
                component: OrderProductTypesButton,
                extraProps: {
                    title: adjustmentOrderProductTypesText,
                    id: 'adjustmentProductTypes',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
        }
    }, [Order, data, onSubmit, adjustmentDeliveryNoteDownloadCSVText, adjustmentDeliveryNoteDownloadPDFTemplateText, adjustmentDeliveryNoteDownloadPDFText, adjustmentDeliveryNotePreviewPDFText, isReadOnly, adjustmentOrderProductTypesText ])

    return { name, ButtonComponents, defaultButtons }
}

export const AdjustmentDeliveryNoteFinishedStepButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useAdjustmentDeliveryNoteFinishedStepButtonsLogic, ...rest }} className='mr-8' />
    )
}

export default AdjustmentDeliveryNoteFinishedStepButtons